export default __webpack_public_path__ + "static/media/023-mountain.52bb2f78.svg";